import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo, forwardRef } from "react";
import Icon from "../../Icon/Icon";
var OkLogoIcon = /*#__PURE__*/forwardRef(function (properties, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("path", {
    d: "M12 5c1.11 0 2.012.902 2.012 2.012A2.013 2.013 0 0112 9.02a2.013 2.013 0 01-2.012-2.008C9.988 5.902 10.891 5 12 5zm0 7.008a4.998 4.998 0 10-.004-9.996A4.998 4.998 0 0012 12.008zm1.965 3.82a8.975 8.975 0 002.82-1.168 1.423 1.423 0 00-1.515-2.406 6.17 6.17 0 01-6.54 0 1.423 1.423 0 10-1.515 2.406 8.938 8.938 0 002.82 1.168l-2.719 2.719a1.42 1.42 0 00.004 2.012 1.418 1.418 0 002.012 0L12 17.89l2.672 2.668a1.424 1.424 0 002.012 0 1.424 1.424 0 000-2.012l-2.72-2.719z",
    fill: "currentColor"
  }));
});
export default /*#__PURE__*/memo(OkLogoIcon);